import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import {
    GET_CATEGORIES,
    GET_SUB_CATEGORIES,
    GET_ALL_SUB_CATEGORIES,
    clientUrl,
} from '../endPoints';
import { baseURL } from '../baseUrl/baseURL';
import { headers } from '../baseUrl/setHeaders';

export const categoryAPI = createApi({
    reducerPath: 'categoryAPI',
    baseQuery: fetchBaseQuery({
        baseUrl: baseURL,
        prepareHeaders: headers,
    }),
    endpoints: (builder) => ({
        getCategories: builder.query({
            query: () => `${GET_CATEGORIES}`,
        }),
        getSingleCategory: builder.query({
            query: (id) => `${GET_CATEGORIES}/${id}`,
        }),
        getSubCategories: builder.query({
            query: (id) => `${GET_SUB_CATEGORIES}/${id}/sub-categories`,
        }),
        getAllSubCategories: builder.query({
            query: (id) => `${GET_ALL_SUB_CATEGORIES}`,
        }),
    }),
});

export const {
    useGetCategoriesQuery,
    useGetSingleCategoryQuery,
    useGetSubCategoriesQuery,
    useGetAllSubCategoriesQuery,
} = categoryAPI;
